import React from 'react';


const view = ({
    login,
    username,
    password,
    onTextChange
}) => {

    return (
        <div className="flex justify-center mt-24">
            <form onSubmit={login} className="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 justify-center items-center">
                <div className="flex flex-col items-center">
                    <p className="text-3xl p-4">مرحبا بك</p>
                    <img alt="logo" src="/images/logo.svg" className="w-64 h-32 mb-10 justify-center align-middle"></img>
                </div>
                <div className="mb-4">
                    <label className="block text-gray-700 text-sm font-normal mb-2" htmlFor="username">
                        اسـم المستخدم
                    </label>
                    <input className="text-gray-900 bg-grey-050 h-8 px-5 pr-2 rounded text-sm border border-grey-100 leading-tight focus:outline-none focus:bg-white focus:border-grey-200 w-full"
                        name="username"
                        type="text"
                        placeholder="اسم المستخدم"
                        value={username}
                        onChange={onTextChange}
                        required
                    />
                </div>
                <div className="mb-6">
                    <label className="block text-gray-700 text-sm font-normal mb-2" htmlFor="password">
                        كلمة السـر
                    </label>
                    <input className="text-gray-900 bg-grey-050 h-8 px-5 pr-2 rounded text-sm border border-grey-100 leading-tight focus:outline-none focus:bg-white focus:border-grey-200 w-full"
                        name="password"
                        type="password"
                        placeholder="*********"
                        value={password}
                        onChange={onTextChange}
                        required
                    />
                </div>
                <div className="flex items-center justify-center">
                    <button type='submit' className="h-10 bg-blue-500 text-gray-300 font-normal rounded hover:bg-vivid-400  hover:text-white shadow-md py-1 px-2 inline-flex items-center">
                        تسجيل الـدخول
                    </button>
                </div>
            </form>
        </div>
    );
};

export default view;